import React from "react";
import TabTemplate from "../../../_shoru_shared_library/template/TabTemplate";
import castingMeetingTabRouter from "./castingMeetingTabRouter";

function CastingMeetingTab(props) {

  return (
    <TabTemplate 
      router={castingMeetingTabRouter}
      passData={props.passData}
    />
  )

}

export default CastingMeetingTab;